import { AddCircleOutline } from "@mui/icons-material";
import { FormControl, FormHelperText } from "@mui/material";
import CreatePhysicalUnitInlineDialog from "components/dialogs/physical-units/CreatePhysicalUnitInlineDialog";
import IndieButton from "components/forms/IndieButton";
import { useFormikContext } from "formik";
import ApplicationList from "page-sections/common/ApplicationList";
import { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePhysicalUnitsAPI } from "service/PhysicalUnitsAPIService";

const SelectOrCreatePhysicalUnitStep = () => {

    const { t } = useTranslation();
    const api = usePhysicalUnitsAPI();
    const { values, errors, setFieldValue } = useFormikContext();

    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const tableRef = useRef();

    const columns = useMemo(() => [
        { accessor: "consumption_deliverypoint", Header: t("label.table.header.consumptionDeliverypoint"), filter: "contains" },
        { accessor: "production_deliverypoint", Header: t("label.table.header.productionDeliverypoint") },
        { accessor: "zip_code", Header: t("label.table.header.zipCode") },
        { accessor: "address", Header: t("label.table.header.address") },
    ], [t]);

    const dataFetcher = (filters = [], page_size = 30, page = 1, sortColumns, callBack, errorCallBack) => {
        api.find(filters, page, page_size, sortColumns, callBack, errorCallBack);
    };

    const handleRowClick = (row) => {
        setFieldValue("physical_unit", row);
        setFieldValue("physical_unit_id", row.id);
    };

    const handleCreateComplete = (physicalUnit) => {
        setOpenCreateDialog(false);
        setFieldValue("physical_unit", physicalUnit);
        setFieldValue("physical_unit_id", physicalUnit.id);
        tableRef.current?.refreshData();
    };

    return (
        <FormControl fullWidth>
            <ApplicationList
                ref={tableRef}
                id="select_physical_unit_table"
                dataFetcher={dataFetcher}
                columns={columns}
                selectable
                selected={values.physical_unit_id ? values.physical_unit : null}
                rowOnClick2={handleRowClick}
                outlined
                showAppBar
                appBar={[
                    <IndieButton key="create_physical_unit" id="button_create_physical_unit" startIcon={<AddCircleOutline />} variant="outlined" onClick={() => setOpenCreateDialog(true)}>
                        {t("label.button.createInstallation")}
                    </IndieButton>
                ]}
            />
            {errors.physical_unit_id && <FormHelperText id="physical_unit_id_helper_text" error>{errors.physical_unit_id}</FormHelperText>}
            <CreatePhysicalUnitInlineDialog
                open={openCreateDialog}
                onClose={() => setOpenCreateDialog(false)}
                onComplete={handleCreateComplete}
            />
        </FormControl>
    );
};

export default SelectOrCreatePhysicalUnitStep;
